import { AnimatePresence, motion } from 'motion/react';
import { cn } from './cn';

export interface CollapseProps {
  /** When true the content expands; when false it collapses. */
  open: boolean;
  children: React.ReactNode;
  /** Class applied to the animated wrapper. */
  className?: string;
}

/**
 * Animated expand/collapse — replaces MUI <Collapse />.
 * Animates height between 0 and `auto` (plus a fade) via motion. Content is kept
 * in an inner wrapper so height:auto resolves correctly for the animation.
 */
export function Collapse({ open, children, className }: CollapseProps) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          className={cn('overflow-hidden', className)}
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          <div>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
